module.exports = __webpack_public_path__ + "static/media/ruling-machine.d832b7d2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/videos/ruling-machine.mp4
// module id = 28
// module chunks = 0